import { coreClient } from './coreclient'

export default {
  async list() {
    const client = await coreClient()
    return client.bulkData
      .list()
      .then((response) => {
        return response.data
      })
      .catch((e) => {
        console.error(e)
        return []
      })
  },
  async get(id: number) {
    const client = await coreClient()
    return client.bulkData
      .get(id)
      .then((response) => {
        if (response.data) {
          return response.data
        }
        return null
      })
      .catch((e) => {
        console.error(e)
        return null
      })
  },
  async update(
    id: number,
    body: { emails_enabled: boolean; emails: string[]; schedule: string[] }
  ) {
    const client = await coreClient()
    return client.bulkData
      .update(id, body)
      .then((response) => {
        if (response.data) {
          return response.data
        }
        return null
      })
      .catch((e) => {
        console.error(e)
        return null
      })
  },
  async sendEmail(id: number) {
    const client = await coreClient()
    return client.bulkData
      .sendEmail(id)
      .then((response) => {
        return response.data
      })
      .catch((e) => {
        console.error(e)
        return false
      })
  }
}
